import { Outlet } from 'react-router-dom';

export const HospitalityOutlet = () => <Outlet />;
